var map = {
	"./blackGold/fragments/plusvector.png": 20966,
	"./brownGold/fragments/plusvector.png": 49537,
	"./darkBlue/fragments/plusvector.png": 93311,
	"./greenYellow/fragments/plusvector.png": 45517,
	"./redGold/fragments/plusvector.png": 98046,
	"./skyBlue/fragments/plusvector.png": 91027,
	"./whiteGold/fragments/plusvector.png": 15015,
	"./yellowWhite/fragments/plusvector.png": 27238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38742;